import {
    FilterDataProvider,
    getFilterDataProvider,
} from "../../../apis/stateful-content";
import { track } from "../../../utils/tracking";

export function initStatefulOverviewTracking(
    scope: string,
    debug: boolean = false
) {
    trackFilterForm(scope, debug);
    trackFilterRemoveButton(scope, debug);
}

function trackFilterRemoveButton(scope: string, debug: boolean = false) {
    const filterRemoveButton = document.querySelector(
        `ux-iws-stateful-filter-remove-button[scope="${scope}"] button`
    ) as HTMLElement;
    if (filterRemoveButton === null) {
        return;
    }
    const onClick = () => {
        track("filter_remove", {}, debug);
    };
    filterRemoveButton.addEventListener("click", onClick);
}

interface FilterUsage {
    [key: string]: string[];
}

function trackFilterForm(scope: string, debug: boolean = false) {
    const filterProvider: FilterDataProvider = getFilterDataProvider(scope);
    const onFilterChange = ({ filterQuery }) => {
        track(
            "filter_usage",
            {
                filter_usage: filterQuery
                    .split("&")
                    .map((pair: string) => pair.split("="))
                    .reduce((acc: FilterUsage, [key, value]) => {
                        const decodedKey = decodeURIComponent(key);
                        const decodedValue = decodeURIComponent(value);
                        if (decodedKey in acc) {
                            acc[decodedKey].push(decodedValue);
                        } else {
                            acc[decodedKey] = [decodedValue];
                        }
                        return acc;
                    }, {}),
            },
            debug,
            "custom_ga4_event"
        );
    };
    filterProvider.subscribe(onFilterChange);
}
